<template>
  <span>
    <gmap-marker
      :position="hydrant.position"
      :clickable="true"
      :icon="{ labelOrigin: google && new google.maps.Point(15,14), url: hydrant.icon}"
      :label="{ fontSize: '10px;', text: monthsSinceLastTest }"
      v-on:click="showInfoWindow"
    >
    </gmap-marker>
    <HydrantMarkerContent ref="hydrantMarkerContent" :hydrant="hydrant" />
  </span>
</template>

<script>
import HydrantMarkerContent from "./HydrantMarkerContent";
import { gmapApi } from 'vue2-google-maps'
import moment from "moment";

export default {
  computed: {
    google: gmapApi,
    monthsSinceLastTest() {
      if (this.hydrant.hydrant_type === "muni") {
        return " "; // single space intentionally
      } else {
        return (this.hydrant.last_tested_at == null ? "!" : moment().diff(moment(this.hydrant.last_tested_at), 'months')).toString()
      }
    }
  },
  components: {
    HydrantMarkerContent
  },
  props: {
    hydrant: {
      type: Object,
      required: true
    }
  },
  methods: {
    showInfoWindow: function() {
      this.$emit(
        "show-info-window",
        this.hydrant,
        this.$refs.hydrantMarkerContent.$el.outerHTML
      );
    }
  }
};
</script>
